import { render } from "./CheckSMSCode.vue?vue&type=template&id=1cee8da2&lang=pug"
import script from "./CheckSMSCode.vue?vue&type=script&lang=js"
export * from "./CheckSMSCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__